import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  ViewChild,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss'],
})
export class TermsAndConditionsComponent implements AfterViewInit {
  text: string = '';

  @ViewChild('textArea')
  textArea!: ElementRef;

  constructor(
    public MD_REF: MatDialogRef<TermsAndConditionsComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { title: string; data: string; inject?: boolean },
  ) {}

  ngAfterViewInit(): void {
    if (this.data.inject)
      this.textArea.nativeElement.innerHTML = this.data.data;
    else this.text = this.data.data;
  }
}
